import { lazy } from 'react';

export const getIsChunkLoadError = (error: Error) => {
  const errorMessage = String(error?.message || '');
  const errorName = String(error?.name || '');

  const isChunkLoadError =
    errorMessage.includes('Failed to fetch dynamically imported module') ||
    errorMessage.includes('Loading chunk') ||
    errorMessage.includes('Loading CSS chunk') ||
    errorMessage.includes('ChunkLoadError') ||
    errorName === 'ChunkLoadError';

  return isChunkLoadError;
};

/**
 * For more info about this function checkout article below
 * https://raphael-leger.medium.com/react-webpack-chunkloaderror-loading-chunk-x-failed-ac385bd110e0
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const lazyWithRetry = (componentImport: any) =>
  lazy(async () => {
    const pageHasAlreadyBeenForcedRefreshed = JSON.parse(
      window.localStorage.getItem('page-has-been-force-refreshed') || 'false'
    );

    try {
      const component = await componentImport();

      window.localStorage.setItem('page-has-been-force-refreshed', 'false');

      return component;
    } catch (error) {
      // Check if this is a chunk loading error (Vite/Webpack dynamic import failure)
      // This happens during version updates when old chunks are no longer available
      const isChunkLoadError = getIsChunkLoadError(error as Error);
      if (!pageHasAlreadyBeenForcedRefreshed) {
        /* Assuming that the user is not on the latest version of the application.
         Let's refresh the page immediately. */
        window.localStorage.setItem('page-has-been-force-refreshed', 'true');

        if (isChunkLoadError) {
          setTimeout(() => {
            window.location.reload(); // dynamically reload the page
          }, 300);
          return;
        }
        return window.location.reload();
      }

      /* The page has already been reloaded
       Assuming that user is already using the latest version of the application.
       Let's let the application crash and raise the error. */
      throw error;
    }
  });
